const t=(t,n)=>{const o=new Map;return t.forEach(((t,u)=>{o.set(t,n[u])})),o},n=(t,n,o)=>[t?"auto":null!=n?n:0,null!=o?o:"auto"];export{t as constructCategoryColors,n as getYAxisDomain};
